import React from "react";

import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FaTachometerAlt,
  FaGem,
  FaList,
  FaGithub,
  FaRegLaughWink,
  FaHeart,
  AiOutlineContacts,
} from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
//import sidebarBg from './assets/bg1.jpg';

const Aside = ({ image, collapsed, rtl, toggled, handleToggleSidebar }) => {
  return (
    <ProSidebar
      // image={image ? sidebarBg : false}
      rtl={rtl}
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="md"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div
          style={{
            padding: "24px",
            textTransform: "uppercase",
            fontWeight: "bold",
            fontSize: 14,
            letterSpacing: "1px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          Laxmi Admin Dashboard
        </div>
      </SidebarHeader>

      <SidebarContent>
        <Menu iconShape="circle">
          <SubMenu title="Homepage" icon={<FaGem />}>
            {/* <MenuItem>
              <NavLink
                to="/admin/dashboard/hompeagebannerlist"
                activeStyle={{
                  color: "white",
                }}
              >
                Banner
              </NavLink>
            </MenuItem> */}
            <MenuItem>
              <NavLink
                to="/admin/dashboard/header/logo"
                activeStyle={{ color: "white" }}
              >
                Header Logo
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/homepage/sliders"
                activeStyle={{
                  color: "white",
                }}
              >
                Sliders
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/HomepageProducts"
                activeStyle={{
                  color: "white",
                }}
              >
                Products
              </NavLink>
            </MenuItem>

            <MenuItem>
              <NavLink
                to="/admin/dashboard/laxmiworld"
                activeStyle={{
                  color: "white",
                }}
              >
                About us
              </NavLink>
            </MenuItem>

            <MenuItem>
              <NavLink
                to="/admin/dashboard/homepage/faq"
                activeStyle={{ color: "white" }}
              >
                FAQ
              </NavLink>
            </MenuItem>

            <MenuItem>
              <NavLink
                to="/admin/dashboard/homepage/findastoresection"
                activeStyle={{ color: "white" }}
              >
                Find a Store Section
              </NavLink>
            </MenuItem>
          </SubMenu>
          {/* <SubMenu title="Header" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/header/logo"
                activeStyle={{ color: "white" }}
              >
                Logo
              </NavLink>
            </MenuItem>
          </SubMenu> */}
          {/*  */}
          <SubMenu title="Our Story" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/ourstorybanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/ourstorywelcome"
                activeStyle={{
                  color: "white",
                }}
              >
                Welcome section
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/ourstoryvisionmission"
                activeStyle={{
                  color: "white",
                }}
              >
                Vision Mission
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/ourstorymilestones"
                activeStyle={{
                  color: "white",
                }}
              >
                Milestones
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/ourstorylaxmipromise"
                activeStyle={{
                  color: "white",
                }}
              >
                Laxmi Promise
              </NavLink>
            </MenuItem>
          </SubMenu>
          {/*  */}

          <SubMenu title="Our Products" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/productbanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/product-categories"
                activeStyle={{
                  color: "white",
                }}
              >
                Categories
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/productsubcategory"
                activeStyle={{
                  color: "white",
                }}
              >
                Sub Categories
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/productunit"
                activeStyle={{
                  color: "white",
                }}
              >
                Units
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/products"
                activeStyle={{
                  color: "white",
                }}
              >
                Products
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/product/content"
                activeStyle={{
                  color: "white",
                }}
              >
                Catalogue
              </NavLink>
            </MenuItem>
          </SubMenu>

          {/*  */}

          <SubMenu title="Store Locator" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/storesbanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/storesstores"
                activeStyle={{
                  color: "white",
                }}
              >
                Stores
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/storesbrands"
                activeStyle={{
                  color: "white",
                }}
              >
                Brands
              </NavLink>
            </MenuItem>
          </SubMenu>
          {/*  */}

          <SubMenu title="Laxmi's Recipes" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/laxmisrecipebanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/laxmisrecipecategories"
                activeStyle={{
                  color: "white",
                }}
              >
                Categories
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/laxmisrecipes"
                activeStyle={{
                  color: "white",
                }}
              >
                Recipes
              </NavLink>
            </MenuItem>
          </SubMenu>
          {/*  */}

          <SubMenu title="Media" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/mediabanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Media Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/mediavideo"
                activeStyle={{
                  color: "white",
                }}
              >
                Media Video
              </NavLink>
            </MenuItem>
          </SubMenu>

          {/*  */}
          <SubMenu title="Blogs" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/blogbanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Blog Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/bloglist"
                activeStyle={{
                  color: "white",
                }}
              >
                Blog List
              </NavLink>
            </MenuItem>
          </SubMenu>
          {/*  */}
          <SubMenu title="Contact Us" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/contactusbanner"
                activeStyle={{
                  color: "white",
                }}
              >
                Contact Us Banner
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/contactusdetails"
                activeStyle={{
                  color: "white",
                }}
              >
                Contact Us Details
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/contactusform"
                activeStyle={{
                  color: "white",
                }}
              >
                Contact Us Form
              </NavLink>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Leads" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/leads/landing-page"
                activeStyle={{
                  color: "white",
                }}
              >
                Landing page form
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/leads/Laxmi-Packaging-Survey-2026"
                activeStyle={{
                  color: "white",
                }}
              >
                Laxmi Packaging Survey 2026
              </NavLink>
            </MenuItem>
          </SubMenu>
          <SubMenu title="FAQ" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                exact
                to="/admin/dashboard/faq/categories"
                activeStyle={{ color: "white" }}
              >
                FAQ: Ingredient Categories
              </NavLink>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Diwali Bonanza" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/leads/diwali-bonanza"
                activeStyle={{
                  color: "white",
                }}
              >
                Entries
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/diwali-bonanza/winners"
                activeStyle={{
                  color: "white",
                }}
              >
                Winners
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/diwali-bonanza/dashboard"
                activeStyle={{
                  color: "white",
                }}
              >
                Gift Dashboard
              </NavLink>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Diwali Bonanza 2025" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/leads/diwali-bonanza-2025"
                activeStyle={{
                  color: "white",
                }}
              >
                Entries
              </NavLink>
            </MenuItem>

            <MenuItem>
              <NavLink
                to="/admin/dashboard/leads/diwali-bonanza-2025/daily-winners"
                activeStyle={{
                  color: "white",
                }}
              >
                Daily Winners
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/diwali-bonanza-2025/winners"
                activeStyle={{
                  color: "white",
                }}
              >
                Weekly Winners
              </NavLink>
            </MenuItem>
          </SubMenu>
          <SubMenu title="Footer" icon={<FaGem />}>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/footer/content"
                activeStyle={{
                  color: "white",
                }}
              >
                Footer Content
              </NavLink>
            </MenuItem>
            <MenuItem>
              <NavLink
                to="/admin/dashboard/footer/social"
                activeStyle={{
                  color: "white",
                }}
              >
                Social Links
              </NavLink>
            </MenuItem>
          </SubMenu>
        </Menu>
      </SidebarContent>

      <SidebarFooter style={{ textAlign: "center" }}>
        <div
          className="sidebar-btn-wrapper"
          style={{
            padding: "20px 24px",
          }}
        ></div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Aside;
